/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Principal } from './Principal';
import {
    PrincipalFromJSON,
    PrincipalFromJSONTyped,
    PrincipalToJSON,
} from './Principal';

/**
 * Object of the comment, which can be added to any Item in the commerce suite.
 * @export
 * @interface Comment
 */
export interface Comment {
    /**
     * Text of the comment.
     * @type {string}
     * @memberof Comment
     */
    text: string;
    /**
     * Date when the comment was created.
     * @type {Date}
     * @memberof Comment
     */
    creationDate: Date;
    /**
     * 
     * @type {Principal}
     * @memberof Comment
     */
    author?: Principal;
    /**
     * Flag showing if the current customer was the author of the comment.
     * @type {boolean}
     * @memberof Comment
     */
    fromCustomer: boolean;
}

/**
 * Check if a given object implements the Comment interface.
 */
export function instanceOfComment(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "text" in value;
    isInstance = isInstance && "creationDate" in value;
    isInstance = isInstance && "fromCustomer" in value;

    return isInstance;
}

export function CommentFromJSON(json: any): Comment {
    return CommentFromJSONTyped(json, false);
}

export function CommentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Comment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'text': json['text'],
        'creationDate': (new Date(json['creationDate'])),
        'author': !exists(json, 'author') ? undefined : PrincipalFromJSON(json['author']),
        'fromCustomer': json['fromCustomer'],
    };
}

export function CommentToJSON(value?: Comment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'text': value.text,
        'creationDate': (value.creationDate.toISOString()),
        'author': PrincipalToJSON(value.author),
        'fromCustomer': value.fromCustomer,
    };
}

